import React , { Component } from 'react';

export default class InProgress extends Component {
    render() {
        return (
            <div>
                <h1> Coming Soon!! </h1>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/InProgress/index.js